
<template>
	<v-row no-gutters>
		<v-col :class="$vuetify.breakpoint.mdAndUp ? 'pr-2' : ''" cols="12" md="6">
			<v-row no-gutters class="px-1 pt-2 show-unit">
				<v-col cols="12" sm="3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
					<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">基本情報</h4>
				</v-col>
				<v-col cols="12" sm="9">
					<v-row no-gutters class="pb-2 show-detail-unit">
						<v-col cols="4">
							<h5 class="text-body-1 text-sm-body-2 font-weight-bold">案件名</h5>
						</v-col>
						<v-col cols="8">
							<p class="text-body-1 text-sm-body-2">{{ matter.name }}</p>
						</v-col>
					</v-row>
					<v-row no-gutters class="pb-2 show-detail-unit">
						<v-col cols="4">
							<h5 class="text-body-1 text-sm-body-2 font-weight-bold">作成日</h5>
						</v-col>
						<v-col cols="8">
							<p class="text-body-1 text-sm-body-2">
								{{ matter.created_at | dateFormatter }}
							</p>
						</v-col>
					</v-row>

					<v-row no-gutters class="pb-2 show-detail-unit">
						<v-col cols="4">
							<h5 class="text-body-1 text-sm-body-2 font-weight-bold">最終更新日</h5>
						</v-col>
						<v-col cols="8">
							<p class="text-body-1 text-sm-body-2">
								{{ matter.updated_at | dateFormatter }}
							</p>
						</v-col>
					</v-row>

					<v-row no-gutters class="pb-2 show-detail-unit">
						<v-col cols="4">
							<h5 class="text-body-1 text-sm-body-2 font-weight-bold">見積番号</h5>
						</v-col>
						<v-col cols="8">
							<p class="text-body-1 text-sm-body-2">
								{{ matter.quotation_number }}-{{ matter.quotation_sub_number }}
							</p>
						</v-col>
					</v-row>

					<v-row no-gutters class="pb-2 show-detail-unit">
						<v-col cols="4">
							<h5 class="text-body-1 text-sm-body-2 font-weight-bold">成約したかどうか</h5>
						</v-col>
						<v-col cols="8">
							<p class="text-body-1 text-sm-body-2" v-if="matter.contract == true">成約</p>
							<p class="text-body-1 text-sm-body-2" v-if="matter.contract == false">失注</p>
							<p class="text-body-1 text-sm-body-2" v-if="matter.contract == null">未定</p>
						</v-col>
					</v-row>

					<v-row no-gutters class="pb-2 show-detail-unit">
						<v-col cols="4">
							<h5 class="text-body-1 text-sm-body-2 font-weight-bold">本件の担当者</h5>
						</v-col>
						<v-col cols="8">
							<p class="text-body-1 text-sm-body-2">
								{{ matter.team_member_name ? matter.team_member_name : "" }}
							</p>
						</v-col>
					</v-row>

					<v-row no-gutters class="pb-2 show-detail-unit">
						<v-col cols="4">
							<h5 class="text-body-1 text-sm-body-2 font-weight-bold">受注確度</h5>
						</v-col>
						<v-col cols="8">
							<p class="text-body-1 text-sm-body-2">
								{{ matter.situation_ja ? matter.situation_ja : "" }}
							</p>
						</v-col>
					</v-row>

					<v-row no-gutters class="pb-2 show-detail-unit">
						<v-col cols="4">
							<h5 class="text-body-1 text-sm-body-2 font-weight-bold">流れ品か否か</h5>
						</v-col>
						<v-col cols="8">
							<p class="text-body-1 text-sm-body-2" v-if="matter.regularly_sold == true">流れ品</p>
							<p class="text-body-1 text-sm-body-2" v-if="matter.regularly_sold == false">否</p>
							<p class="text-body-1 text-sm-body-2" v-if="matter.regularly_sold == null">未設定</p>
						</v-col>
					</v-row>

					<v-row no-gutters class="pb-2 show-detail-unit">
						<v-col cols="4">
							<h5 class="text-body-1 text-sm-body-2 font-weight-bold">案件の概要</h5>
						</v-col>
						<v-col cols="8">
							<p class="text-body-1 text-sm-body-2">
								{{ matter.description ? matter.description : "" }}
							</p>
						</v-col>
					</v-row>
					<v-row no-gutters class="pb-2 show-detail-unit">
						<v-col cols="4">
							<h5 class="text-body-1 text-sm-body-2 font-weight-bold">得意先</h5>
						</v-col>
						<v-col cols="8">
							<p class="text-body-1 text-sm-body-2">
								{{ matter.regular_customer_company ? matter.regular_customer_company.name : "" }}
							</p>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
		<v-col :class="$vuetify.breakpoint.mdAndUp ? 'pl-2' : ''" cols="12" md="6">
			<v-row no-gutters class="px-1 pt-2 show-unit">
				<v-col cols="12" sm="3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
					<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">製品情報</h4>
				</v-col>
				<v-col cols="12" sm="9">
					<div
						v-for="ordered_product in matter.products_by_contract"
						:key="ordered_product.id"
						class="top-divider pt-2"
					>
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-1 text-sm-body-2 font-weight-bold">製品名</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-1 text-sm-body-2">
									{{ ordered_product.product.name }}
								</p>
							</v-col>
						</v-row>
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h4 class="text-body-1 text-sm-body-2 font-weight-bold">サブネーム</h4>
							</v-col>
							<v-col cols="8">
								<h4 class="text-body-1 text-sm-body-2">{{ ordered_product.sub_name }}</h4>
							</v-col>
						</v-row>
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h4 class="text-body-1 text-sm-body-2 font-weight-bold">単価</h4>
							</v-col>
							<v-col cols="8">
								<h4 class="text-body-1 text-sm-body-2">
									{{ Number(ordered_product.unit_price).toLocaleString() + "円" }}
								</h4>
							</v-col>
						</v-row>
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h4 class="text-body-1 text-sm-body-2 font-weight-bold">数量</h4>
							</v-col>
							<v-col cols="8">
								<h4 class="text-body-1 text-sm-body-2">{{ ordered_product.quantity }}</h4>
							</v-col>
						</v-row>
					</div>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import moment from "moment/min/moment.min.js"

export default {
	props: {
		matter: {
			type: Object,
			required: true,
		},
	},
	filters: {
		dateFormatter(date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	data() {
		return {}
	},
}
</script>

<style>
</style>